import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import ContactForm from "./components/ContactForm";

const infoItems = [
  { icon: "ri-phone-line", label: "전화", value: "02-002-2525" },
  { icon: "ri-time-line", label: "운영시간", value: "평일 13:00 - 22:00 · 토 10:00 - 18:00" },
  { icon: "ri-map-pin-line", label: "위치", value: "서울특별시 서초구 반포대로 123, 4층" },
];

export default function Consult() {
  return (
    <>
      <PageHero
        tag="CONSULTATION"
        title={
          <>
            지금의 실력을 진단하면
            <br />
            <span className="text-primary-500">다음 성적이 보입니다</span>
          </>
        }
        description="상담 신청을 남겨주시면 담당 선생님이 학습 진단과 함께 가장 적합한 반을 안내해 드립니다. 상담은 무료입니다."
        image="https://readdy.ai/api/search-image?query=Abstract%20stylized%20dark%20composition%20with%20glowing%20lime%20green%20connection%20nodes%20and%20abstract%20geometric%20paths%20linking%20together%20over%20a%20deep%20charcoal%20background%2C%20soft%20volumetric%20light%2C%20minimal%20editorial%20poster%20art%2C%20cinematic%20depth%2C%20no%20text&width=1920&height=720&seq=mbhj-consult-hero-01&orientation=landscape"
      />

      <section className="bg-background-50 py-16 md:py-24">
        <div className="mx-auto max-w-content px-5 md:px-8">
          <div className="grid gap-10 lg:grid-cols-12 lg:gap-12">
            <Reveal className="lg:col-span-7">
              <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
                상담 신청
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                아래 내용을 작성해 주시면, 담당 선생님이 확인 후 연락드립니다.
              </p>
              <div className="mt-6">
                <ContactForm />
              </div>
            </Reveal>

            <Reveal delay={100} className="lg:col-span-5">
              <div className="space-y-4">
                <div className="rounded-2xl border border-background-200 bg-background-100/70 p-6">
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    학원 정보
                  </h3>
                  <ul className="mt-5 space-y-5">
                    {infoItems.map((item) => (
                      <li key={item.label} className="flex items-start gap-3">
                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                          <i className={`${item.icon} text-lg`} />
                        </span>
                        <div>
                          <p className="font-label text-[11px] tracking-wide text-foreground-600">
                            {item.label}
                          </p>
                          <p className="mt-0.5 text-sm font-bold text-foreground-950">
                            {item.value}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="rounded-2xl bg-foreground-950 p-6 text-white">
                  <h3 className="font-heading text-base font-bold">상담 안내</h3>
                  <p className="mt-3 text-sm leading-relaxed text-white/70">
                    상담 시 학생의 최근 시험 성적표나 학습지가 있으시면 함께
                    준비해 주세요. 보다 정확한 진단과 상담이 가능합니다.
                  </p>
                  <a
                    href="tel:020022525"
                    className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-sm font-bold text-foreground-950 transition-colors hover:bg-primary-400 cursor-pointer"
                  >
                    <i className="ri-phone-line" />
                    전화로 바로 상담
                  </a>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}